module.exports = __webpack_public_path__ + "assets/9cff8f181c8a1b3e057a60847c096ee2.mp4";